import { Banner } from '@/components/banner/banner.comp';
import { DiscoverHero } from '@/components/discoverHero/discoverHero.comp';
import { Layout } from '@/components/layout/layout.comp';
import { MoreApps } from '@/components/moreApps/moreApps.comp';
import { Platforms } from '@/components/platforms/platforms.comp';
import { WidgetCatalog } from '@/components/widgetCatalog/widgetCatalog.comp';
import { searchClient } from '@/globals/algolia.global';
import { getDataFromDB } from '@/lib/mongodb';
import clientPromise, {
	getSearchEngineDataDB,
} from '@/lib/searchEngineMongodb';
import { IPlatform, IPlugin } from '@/types';
import Script from 'next/script';
import { InstantSearch } from 'react-instantsearch-dom';

export default function Home({
	apps,
	platforms,
	totalApps,
}: {
	apps: IPlugin[];
	platforms: IPlatform[];
	totalApps: number;
}) {
	const alphabet = 'abcdefghijklmnopqrstuvwxyz';

	return (
		<Layout
			showFooter={true}
			showHeader={true}
			url={`https://discover.commoninja.com/`}
		>
			{loadScripts()}
			<DiscoverHero platforms={platforms} totalApps={totalApps} />
			<Platforms />
			<WidgetCatalog apps={apps} />
			<InstantSearch
				indexName={process.env.NEXT_PUBLIC_ALGOLIA_APPS_INDEX as string}
				searchClient={searchClient}
			>
				<MoreApps
					appSynonym="app"
					query={alphabet[Math.floor(Math.random() * alphabet.length)]} // Random letter
				/>
			</InstantSearch>
			<Banner />
		</Layout>
	);
}

export async function getStaticProps() {
	const platforms = await getSearchEngineDataDB<IPlatform>(
		'platforms',
		{},
		{
			displayName: 1,
			name: 1,
		}
	);

	const client = await clientPromise;
	const db = client.db('searchengine_db');
	const totalApps = await db.collection('platformapps').countDocuments();
	const apps = await getDataFromDB<IPlugin>('apps', {
		status: 'published',
	});
	const randomApps = apps.sort(() => 0.5 - Math.random()).splice(0, 12);

	return {
		props: { apps: randomApps, platforms, totalApps: totalApps || 0 },
	};
}

function loadScripts() {
	return (
		<>
			<Script id="discover-script" type="application/ld+json">{`
        {
          "@context": "https://schema.org/",
          "@type": "WebSite",
          "name": "Find the best apps for your website | Common Ninja",
          "url": "https://discover.commoninja.com/",
          "potentialAction": {
            "@type": "SearchAction",
            "target": "https://discover.commoninja.com/results?q={search_term_string}&orderBy=popular",
            "query-input": "required name=search_term_string"
          }
        }
        `}</Script>
		</>
	);
}
